import { __assign, __rest } from "tslib";
import * as React from 'react';
/**
 * An Info component displaying an info symbol with some text.
 */
export var Info = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement("p", __assign({}, props),
        React.createElement("small", null,
            React.createElement("i", { className: "fas fa-info-circle" }),
            " ",
            children)));
};
//# sourceMappingURL=index.js.map